import React, { useState } from "react";
import Div100vh from "react-div-100vh";
import styled from "styled-components";
import ArrowSvg from "../../../../../assets/images/arrow-back.svg";
import HomeSvg from "../../../../../assets/images/home-red.svg";
import ArrowRight from "../../../../../assets/images/right-white.svg";
import SimpleModal from "../../../../components/shared/MessageModal";
import useLocalStorage from "../../../../hooks/useLocalStorage";
import CustomButton from "../../../shared/CustomButton";
import InputField from "../../../shared/InputField";
import Signature from "../../../shared/Signature";

const SummaryContainer = styled.div`
  padding: 20px 0 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--main-bg-color);
`;
const SummaryHeader = styled.div`
  padding: 0 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const TitleHeader = styled.h3`
  font-size: 19px;
  line-height: 26px;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
  font-weight: normal;
  color: #58595b;
  @media screen and (max-width: 320px) {
    font-size: 20px;
    line-height: 30px;
  }
`;
const SummaryListBody = styled.div`
  padding: 20px 28px 0;
  flex-grow: 1;
  overflow-y: auto;
  background-color: white;
  @media screen and (max-width: 360px) {
    margin-top: 20px;
  }
`;
const SummaryBody = styled.div`
  padding: 0 28px;
  flex-grow: 1;
  overflow-y: auto;
  margin-top: 20px;
  max-height: 40%;
  @media screen and (max-width: 360px) {
    margin-top: 20px;
  }
  @media screen and (max-width: 320px) {
    ${"" /* margin-top: 0 */}
  }
`;
const SummaryList = styled.div`
  overflow: auto;
`;
const SummaryItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 1em 0;
`;
const LeftItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const IdItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  color: #58595b;
  font-size: 13px;
  line-height: 18px;
`;
const GuideItem = styled.div`
  color: #000000;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.005em;
`;
const LocationItem = styled.div`
  color: #ff6868;
  letter-spacing: 0.005em;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  display: flex;
  align-items: center;
`;
const RightItem = styled.div`
  display: flex;
  align-items: center;
  color: #ff6868;
  font-weight: 600;
  font-size: 17px;
  letter-spacing: -0.015em;
`;
const ChargerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 28px;
  margin-top: 1em;
  justify-content: flex-start;
  background: #f9f9f9;
  border-radius: 20px;
  @media screen and (max-width: 320px) {
    margin-top: 1em;
  }
`;
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1em;
`;
const SummaryFooter = styled.div`
  padding: 0px 28px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: auto;
  padding: 1em 0;
  background: #f9f9f9;
`;
const ImgBackContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 16px;
`;
const ImgBack = styled.img`
  width: 16px;
  height: auto;
`;
const GuideNumber = styled.span`
  font-family: OpenSansBold;
`;
const LocationIcon = styled.img`
  width: 15px;
  height: auto;
  margin-right: 6px;
`;
const ImgLogo = styled.img`
  width: 50px;
  height: auto;
`;
const PickupTitle = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 23px;
  margin: 4px 0;
  color: #333333;
  letter-spacing: -0.015em;
`;
const PickupAddress = styled.p`
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: #58595b;
  letter-spacing: 0.005em;
`;
const TotalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 2px 0;
`;
const TotalLabel = styled.p`
  font-weight: bold;
  font-size: 17px;
  line-height: 23px;
  color: ${(props) => props.color || "color: #333333;"};
`;
const LeadingDots = styled.div`
  border-bottom: ${(props) => `1px ${props.color} dashed;`};
  flex: 1;
  margin: 0px 7px;
  margin-bottom: 4px;
`;
const SummaryTotal = styled.div`
  margin-top: 11px;
`;
const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  justify-content: flex-end;
`;
const ButtonList = styled.div`
  background-color: #9240c9;
  border: 1px solid #9240c9;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const ButtonText = styled.p`
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.015em;
  color: #ffffff;
`;
const ButtonImage = styled.img`
  width: 7px;
  height: auto;
  margin-left: 10px;
`;

const Summary = ({
  processedCuds = [],
  showSummary = false,
  onClickCancel,
  handleSignature,
  goBack,
  activeTab,
}) => {
  const [currentScreen, setScreen] = useState(0);
  const [charger, setCharger] = useState({ name: "", dni: "" });
  const [image, setImage] = useState(null);
  const [modalWarning, setModalWarning] = useState(false);
  const [userappret] = useLocalStorage("userappret");
  const [productsOrigin, setProductsOrigin] = useState("ripley");
  // const history = useHistory()

  const onCloseSignature = () => {
    setScreen(0);
  };

  const onSend = () => {
    handleSignature(image, charger);
  };

  const handleChangeCharger = (evt, name) => {
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    if (key === "dni" && (isNaN(value) || value.length > 8)) return;
    setCharger({ ...charger, [key]: value });
  };

  const getProductDetailSummary = (origin) => {
    processedCuds.map((product) => console.log(product));
    setProductsOrigin(origin);
  };
  const getTotalProductsByOrigin = (origin) => {
    const filterByOrigen = processedCuds.filter((x) => x.type.match(origin));
    let total = 0;
    console.log("esto es filter:", filterByOrigen);
    origin === "ripley"
      ? filterByOrigen.map((x) => (total += x.numProducts || 1))
      : filterByOrigen.map((skus) =>
          skus.skus.map((sku) => (total += sku.quantity))
        );
    return total;
  };

  const renderScreen = () => {
    switch (currentScreen) {
      case 1:
        return (
          <Signature
            hasTwoButtons={true}
            onClose={onCloseSignature}
            onSend={(image) => {
              setImage(image);
              setModalWarning(true);
            }}
            message={
              activeTab === 0
                ? "Dejo en constancia haber recepcionado de manera conforme los productos detallados anteriormente."
                : "Dejo constancia de que los productos detallados anteriormente están siendo retirados"
            }
            btn1="CANCELAR"
            btn2="FINALIZAR"
          />
        );
      case 2:
        return (
          <Div100vh
            key={"summary-main"}
            className={`mobile-container-absolute ${
              showSummary ? "showsummary" : ""
            }`}
          >
            <SummaryContainer>
              <SummaryHeader>
                <ImgBackContainer onClick={() => setScreen(0)}>
                  <ImgBack src={ArrowSvg} alt="atras" />
                </ImgBackContainer>
                <TitleHeader>Detalles de productos</TitleHeader>
              </SummaryHeader>
              <div className="reception-tabs">
                <div
                  className={productsOrigin === "ripley" && "active"}
                  onClick={() => getProductDetailSummary("ripley")}
                >
                  Ripley ({getTotalProductsByOrigin("ripley")})
                </div>
                <div
                  className={productsOrigin === "mkp" && "active"}
                  onClick={() => getProductDetailSummary("mkp")}
                >
                  Marketplace ({getTotalProductsByOrigin("mkp")})
                </div>
              </div>
              <SummaryListBody>
                <SummaryList>
                  {processedCuds.length > 0 &&
                    processedCuds.map((pc) => {
                      return (
                        productsOrigin === pc.type && (
                          <SummaryItem key={pc.id}>
                            <LeftItem>
                              {pc.type === "mkp" ? (
                                <>
                                  <GuideItem>
                                    OC:{" "}
                                    <GuideNumber> {pc.suborder} </GuideNumber>
                                  </GuideItem>
                                  {pc.skus.map((sku) => (
                                    <IdItem key={sku.sku}>
                                      SKU: {sku.sku}
                                      <RightItem>
                                        {`x${sku.quantity}`}
                                      </RightItem>
                                    </IdItem>
                                  ))}
                                  <LocationItem>
                                    <LocationIcon
                                      src={HomeSvg}
                                      alt="locacion"
                                    />
                                    {pc.location}
                                  </LocationItem>
                                </>
                              ) : (
                                <>
                                  {console.log(pc)}
                                  <GuideItem>
                                    Guía: <GuideNumber>{pc.guide}</GuideNumber>
                                  </GuideItem>
                                  <IdItem>
                                    CUD: {pc.id}
                                    <RightItem>
                                      {`x${pc.numProducts || 1}`}
                                    </RightItem>
                                  </IdItem>
                                  <LocationItem>
                                    <LocationIcon
                                      src={HomeSvg}
                                      alt="locacion"
                                    />
                                    {pc.location}
                                  </LocationItem>
                                </>
                              )}
                            </LeftItem>
                          </SummaryItem>
                        )
                      );
                    })}
                </SummaryList>
              </SummaryListBody>
            </SummaryContainer>
            <style jsx>{`
              .active {
                color: var(--main-primary-color);
                font-weight: bold;
                background-color: white;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
              }
              .reception-tabs {
                width: 100%;
                display: flex;
                flex-direction: row;
                margin-top: 20px;
              }
              .reception-tabs > div {
                width: 50%;
                text-align: center;
                font-style: normal;
                font-size: 15px;
                line-height: 20px;
                padding: 12px 0;
                cursor: pointer;
              }
            `}</style>
          </Div100vh>
        );
      default:
        return (
          <Div100vh
            key={"summary-main"}
            className={`mobile-container-absolute ${
              showSummary ? "showsummary" : ""
            }`}
          >
            <SummaryContainer>
              <SummaryHeader>
                <ImgBackContainer onClick={() => goBack()}>
                  <ImgBack src={ArrowSvg} alt="atras" />
                </ImgBackContainer>
                <TitleHeader>
                  Resumen de {activeTab === 0 ? "recepción" : "devolución"}
                </TitleHeader>
              </SummaryHeader>

              <SummaryBody>
                <ImgLogo src={userappret.operatorImage} alt="operador" />
                <PickupTitle>{userappret.title}</PickupTitle>
                <PickupAddress>{userappret.address}</PickupAddress>
                <SummaryTotal>
                  <TotalContainer>
                    <TotalLabel>Productos Ripley</TotalLabel>
                    <LeadingDots color="#A0A2A6" />
                    <TotalLabel>
                      {getTotalProductsByOrigin("ripley")}
                    </TotalLabel>
                  </TotalContainer>
                  <TotalContainer>
                    <TotalLabel>Productos Marketplace</TotalLabel>
                    <LeadingDots color="#A0A2A6" />
                    <TotalLabel>{getTotalProductsByOrigin("mkp")}</TotalLabel>
                  </TotalContainer>
                  <TotalContainer>
                    <TotalLabel color="#FF6868">Total de productos</TotalLabel>
                    <LeadingDots color="#FF6868" />
                    <TotalLabel color="#FF6868">
                      {getTotalProductsByOrigin("ripley") +
                        getTotalProductsByOrigin("mkp")}
                    </TotalLabel>
                  </TotalContainer>
                </SummaryTotal>

                <ButtonRow>
                  <ButtonList onClick={() => setScreen(2)}>
                    <ButtonText>Ver detalles de productos</ButtonText>
                    <ButtonImage src={ArrowRight} alt="Ir" />
                  </ButtonList>
                </ButtonRow>
              </SummaryBody>
              <ChargerContainer>
                <TitleHeader>
                  {activeTab === 0 ? "Encargado punto de retiro" : "Encargado"}
                </TitleHeader>
                <InputContainer>
                  <InputField
                    type="text"
                    name="name"
                    label="Nombre"
                    value={charger.name}
                    handleChange={handleChangeCharger}
                    placeholder={"Ej, José Benavides"}
                  />
                  <InputField
                    type="text"
                    name="dni"
                    label="Dni"
                    value={charger.dni}
                    handleChange={handleChangeCharger}
                    placeholder={"########"}
                  />
                </InputContainer>
              </ChargerContainer>
              <SummaryFooter>
                <CustomButton
                  margin="0"
                  onClick={onClickCancel}
                  disabled={false}
                >
                  CANCELAR
                </CustomButton>
                <CustomButton
                  filled
                  margin="0"
                  onClick={() => setScreen(1)}
                  disabled={
                    processedCuds.length <= 0 || !charger.name || !charger.dni
                  }
                >
                  SIGUIENTE
                </CustomButton>
              </SummaryFooter>
            </SummaryContainer>
          </Div100vh>
        );
    }
  };

  return (
    <>
      <SimpleModal
        txtBtn1="VOLVER"
        visible={modalWarning}
        onClickBtn1={() => {
          setModalWarning(false);
        }}
        txtBtn2={"CONFIRMAR"}
        onClickBtn2={() => {
          setModalWarning(false);
          onSend();
        }}
        type={10}
        closeModal={() => setModalWarning(false)}
        title={"¿Seguro que deseas finalizar?"}
      >
        <div className="modal-warning-message">
          <p>
            Una vez finalizado el proceso, <span>no podrás editar</span> los
            datos del encargado.
          </p>
        </div>
      </SimpleModal>
      {renderScreen()}
    </>
  );
};
export default Summary;
